<template>
  <v-img
    :src="backgroundImg"
    class="page-vimg"
  >
    <v-container fill-height pa-0>
      <v-layout align-center>
        <v-flex xs12>
          <v-card
            class="text-xs-center margin-auto border-radius6 box-white-500-glow elevation-10 auth-box"
          >
            <v-layout align-center justify-center row fill-height wrap>
              <v-flex xs12 class="text-xs-center mt-3">
                <img src="/static/vuse-circle-white.svg" alt="Vuse" class="text-xs-center" height="100">
                <div class="headline">Forgot Password</div>
                <v-form @submit.prevent="$v.$invalid ? null : submit()" ref="form">
                  <v-layout wrap row pa-4>
                    <v-flex xs12 pa-0>
                      <v-text-field
                        color="primary"
                        label="Email"
                        v-model="form.email"
                        required
                        :error-messages="fieldErrors('form.email')"
                        @blur="$v.form.email.$touch()"
                      ></v-text-field>

                      <div class="width-150x margin-horiz-center">

                      </div>
                    </v-flex>

                    <v-flex xs12>
                      <v-layout row wrap text-xs-center>
                        <!-- Login form submit -->
                        <v-flex xs12 class="no-mrpd">
                          <v-btn
                            color="act"
                            type="submit"
                            :disabled="$v.$invalid"
                            block
                            :class="$v.$invalid ? '' : 'white--text'"
                          >Reset Password</v-btn>
                        </v-flex>
                        <!-- Forgot password -->
                        <v-flex xs12>

                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>

              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      absolute
      top
      right
      :color="snackcolor"
    >
      <span>{{snacktext}}</span>
      <v-icon dark>check_circle</v-icon>
    </v-snackbar>
   <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-img>
</template>

<script>
import firebase from "firebase";

import { required, email, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";

const defaultForm = {
  email: "jlcumplido+4@gmail.com",
  password: "123456",
  rememberme: false
};
export default {
  mixins: [validationMixin],
  validations: {
    form: {
      email: { required, email },
      password: { required, minLength: minLength(6) }
    }
  },
  validationMessages: {
    form: {
      email: {
        required: "Please enter email",
        email: "Email must be valid"
      },
      password: {
        required: "Please enter password",
        minLength: "Password must be of 6 characters"
      }
    }
  },
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      snackbar: false,
      snackcolor: "act",
      snacktext: "Sign in successful",
      dialog: false,
      backgroundImg: "/static/doc-images/HexesisMaterial01.png"
    };
  },
  methods: {
    submit() {
      this.dialog = true;
      const self = this;

      var auth = firebase.auth();
      var emailAddress = this.form.email;

      auth.sendPasswordResetEmail(emailAddress).then(function() {
              self.snacktext =
                "Please use the link in the email you have received";
              self.snackcolor = "green";
            self.snackbar = true;      
          }).catch(function() {
              self.snacktext =
                "Your email is not valid";
              self.snackcolor = "red";
              self.snackbar = true;      
          });
       
    },
   
    submit2() {
      this.snackbar = true;
      this.resetForm();
      this.$v.$reset();
      setTimeout(() => {
        this.$router.push({
          name: "dashboard/Dashboardv1"
        });
      }, 2000);
    },
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
    }
  }
};
</script>
